import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherUpdateStorageTankSaga() {
  yield takeEvery("UPDATE_STORAGE_TANK", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};

    payload = yield request(
      "patch",
      action.payload,
      `/update-storage-tank/${action.payload.id}`
    );
    toast.success(payload);

    var formatUrl = `/get-storage-tanks`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "STORAGE_TANKS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log(e.response);
    console.log("update-storage-saga", e);
    console.log("update-storage-saga", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "DISPLAY_LOADER" });
    yield put({ type: "API_ERRORED", payload: e });
  }
}
